import React from 'react';
import { Link } from 'react-router-dom';
import Navbar from '../layout/Navbar';
import Footer from '../layout/Footer';

const styles = {
  wrapper: {
    display: 'flex',
    flexDirection: 'column',
    minHeight: '100vh',
  },
  content: {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    textAlign: 'center',
    padding: '2rem',
  },
  code: {
    fontSize: '7rem',
    fontWeight: '700',
    color: '#45A04E',
    lineHeight: 1,
    margin: 0,
  },
  heading: {
    fontSize: '1.5rem',
    fontWeight: '600',
    color: '#1a1a1a',
    margin: '1rem 0 2rem',
  },
  button: {
    display: 'inline-block',
    backgroundColor: '#f26722',
    color: '#fff',
    padding: '0.75rem 2rem',
    borderRadius: '4px',
    textDecoration: 'none',
    fontWeight: '600',
    fontSize: '1rem',
    transition: 'background-color 0.2s',
  },
};

export default function NotFound() {
  return (
    <div style={styles.wrapper}>
      <Navbar />
      <main style={styles.content}>
        <p style={styles.code}>404</p>
        <p style={styles.heading}>Oops! The page you&apos;re looking for doesn&apos;t exist.</p>
        <Link to="/" style={styles.button}>Return to Home</Link>
      </main>
      <Footer />
    </div>
  );
}
